import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    RouterLink,
    ToggleButtonComponent
  ]
})
export class HeaderComponent {
  public configService = inject(ConfigService)
}
